import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

interface Testimonial {
  quote: string;
  author: string;
}

const testimonials: Testimonial[] = [
  {
    quote: 'They showed me that ChatGPT was recommending my competitors not me. Two weeks after installing, that changed.',
    author: 'Max R.',
  },
  {
    quote: 'I had no idea AI search was even a channel. The visibility review was a wake-up call.',
    author: 'Cassius K.',
  },
  {
    quote: 'Review took 15 minutes and I saw what we was missing. A month later AI assistants were referencing us by name.',
    author: 'Anton K.',
  },
];

function StarRow() {
  return (
    <div className="flex items-center justify-center gap-1">
      {Array.from({ length: 5 }).map((_, i) => (
        <FontAwesomeIcon key={i} icon={faStar} className="text-star text-[13px]" />
      ))}
    </div>
  );
}

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <div className="flex flex-col items-center gap-5">
      <StarRow />
      <div className="flex flex-col items-center gap-3">
        <p className="font-body font-medium text-[16px] text-[#1e1c1c] leading-[1.5] text-center">
          {testimonial.quote}
        </p>
        <span className="font-body font-medium text-[16px] text-[rgba(30,28,28,0.7)]">
          {testimonial.author}
        </span>
      </div>
    </div>
  );
}

export default function TestimonialsGrid() {
  return (
    <section className="flex flex-col items-center text-center px-4 md:px-0">
      <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c] max-w-[640px]">
        Businesses using ByLLMs are the ones AI recommends.
      </h2>

      <div className="mt-12 w-full max-w-[960px]">
        <div className="flex flex-col md:flex-row gap-8 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.author} className="flex-1">
              <TestimonialCard testimonial={t} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
